/* ZEPHIR - Reproductor de las notas de voz de las resenas.
 *
 * MEJORA PROGRESIVA, no sustitucion: el HTML ya trae un <audio controls> que
 * funciona solo. Este archivo lo esconde y pinta uno que pega con la ficha. Si
 * falla, queda el nativo y el audio SE SIGUE OYENDO. Es la misma regla del
 * histograma de resenas y del selector de color: lo que se rescata nunca puede
 * depender de que corra un script.
 *
 * SOLO SUENA UNO A LA VEZ: hay fichas con dos notas de voz (buzo-basico,
 * vestido-aurora, cardigan-fiori). Al darle a una, las demas se paran.
 *
 * EL CONTROL REAL ES EL <button>, con teclado y aria-label que cambia entre
 * "Escuchar" y "Pausar". La barra es decorativa (aria-hidden) y se puede
 * pinchar para avanzar: un extra de raton sobre audios de 10-40 segundos.
 *
 * EL TIEMPO QUE SE MUESTRA ES EL QUE FALTA, no el transcurrido: en un audio de
 * 20 segundos lo util es saber cuanto queda por escuchar.
 */
(function () {
  'use strict';

  var ICONO_PLAY  = '<svg viewBox="0 0 10 11" aria-hidden="true"><path d="M0 0l10 5.5L0 11z"/></svg>';
  var ICONO_PAUSA = '<svg viewBox="0 0 10 11" aria-hidden="true"><rect x="0" y="0" width="3.4" height="11"/><rect x="6.6" y="0" width="3.4" height="11"/></svg>';

  function reloj(s) {
    if (!isFinite(s) || s < 0) s = 0;
    var m = Math.floor(s / 60);
    var r = Math.floor(s % 60);
    return m + ':' + (r < 10 ? '0' : '') + r;
  }

  function montar(caja) {
    if (caja.getAttribute('data-zvoz-ok') === '1') return;
    var audio = caja.querySelector('audio');
    if (!audio) return;
    caja.setAttribute('data-zvoz-ok', '1');

    var quien = caja.getAttribute('data-quien') || '';
    var sufijo = quien ? ' la nota de voz de ' + quien : ' la nota de voz';

    var player = document.createElement('div');
    player.className = 'zvoz__player';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'zvoz__btn';
    btn.innerHTML = ICONO_PLAY;
    btn.setAttribute('aria-label', 'Escuchar' + sufijo);

    var barra = document.createElement('div');
    barra.className = 'zvoz__barra';
    barra.setAttribute('aria-hidden', 'true');
    var relleno = document.createElement('i');
    barra.appendChild(relleno);

    var t = document.createElement('span');
    t.className = 'zvoz__t';
    t.textContent = '0:00';

    player.appendChild(btn);
    player.appendChild(barra);
    player.appendChild(t);
    caja.appendChild(player);

    audio.removeAttribute('controls');
    caja.classList.add('is--js');

    function pinta() {
      var d = audio.duration;
      var hayDur = isFinite(d) && d > 0;
      relleno.style.width = (hayDur ? (audio.currentTime / d) * 100 : 0) + '%';
      t.textContent = reloj(hayDur ? d - audio.currentTime : audio.currentTime);
    }

    audio.addEventListener('loadedmetadata', pinta);
    audio.addEventListener('timeupdate', pinta);

    audio.addEventListener('play', function () {
      /* solo uno sonando */
      var otros = document.querySelectorAll('[data-zvoz] audio');
      for (var i = 0; i < otros.length; i++) {
        if (otros[i] !== audio && !otros[i].paused) otros[i].pause();
      }
      btn.innerHTML = ICONO_PAUSA;
      btn.setAttribute('aria-label', 'Pausar' + sufijo);
    });

    function aPausa() {
      btn.innerHTML = ICONO_PLAY;
      btn.setAttribute('aria-label', 'Escuchar' + sufijo);
    }
    audio.addEventListener('pause', aPausa);

    /* Al terminar se vuelve al principio DE VERDAD (currentTime = 0), no solo
       de aspecto: asi la barra y el tiempo quedan como al empezar y el
       siguiente play arranca desde cero. Poner la barra a 0 sin mover el audio
       no servia de nada -- el repintado la devolvia al 100% acto seguido. */
    audio.addEventListener('ended', function () {
      aPausa();
      try { audio.currentTime = 0; } catch (e) {}
      pinta();
    });

    btn.addEventListener('click', function () {
      if (audio.paused) {
        var p = audio.play();
        /* si el navegador rechaza la reproduccion, devolvemos el nativo en vez
           de dejar un boton que no hace nada */
        if (p && p.catch) {
          p.catch(function () {
            caja.classList.remove('is--js');
            audio.setAttribute('controls', 'controls');
          });
        }
      } else {
        audio.pause();
      }
    });

    barra.addEventListener('click', function (e) {
      var d = audio.duration;
      if (!isFinite(d) || d <= 0) return;
      var r = barra.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width;
      if (x < 0) x = 0;
      if (x > 1) x = 1;
      audio.currentTime = x * d;
      pinta();
    });

    pinta();
  }

  function arrancar() {
    var cajas = document.querySelectorAll('[data-zvoz]');
    for (var i = 0; i < cajas.length; i++) montar(cajas[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', arrancar);
})();
